/* Foshe Marquee — rAF-driven horizontal scroll.
 * Replaces CSS keyframe animation because some browsers (notably Brave with
 * fingerprint shields up) suppress CSS keyframe animations via
 * prefers-reduced-motion: reduce regardless of OS setting.
 *
 * Usage:
 *   HTML: <div class="foshe-marquee" style="--marquee-duration: 30s;">
 *           <div class="foshe-marquee__viewport">
 *             <div class="foshe-marquee__track">...</div>
 *             <div class="foshe-marquee__track" aria-hidden="true">...</div>
 *           </div>
 *         </div>
 *
 * Behavior: hover pauses; reduced-motion slows to 3x duration.
 */
(function () {
  'use strict';

  function initMarquee(root) {
    var tracks = root.querySelectorAll('.foshe-marquee__track');
    if (tracks.length === 0) return;

    // Read duration from CSS custom property (set via inline style from Liquid).
    var durationRaw = getComputedStyle(root).getPropertyValue('--marquee-duration').trim();
    var durationSec = parseFloat(durationRaw) || 30;

    // Gracefully slow for users who prefer reduced motion — don't kill it.
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) durationSec = durationSec * 3;

    var durationMs = durationSec * 1000;
    var paused = false;
    var pauseStartedAt = 0;
    var loopOrigin = performance.now();

    root.addEventListener('mouseenter', function () {
      if (!paused) {
        paused = true;
        pauseStartedAt = performance.now();
      }
    });
    root.addEventListener('mouseleave', function () {
      if (paused) {
        paused = false;
        loopOrigin += performance.now() - pauseStartedAt;
      }
    });

    function frame(now) {
      if (!paused) {
        var elapsed = (now - loopOrigin) % durationMs;
        var progress = elapsed / durationMs;
        var translate = -progress * 100;
        for (var i = 0; i < tracks.length; i++) {
          tracks[i].style.transform = 'translate3d(' + translate + '%, 0, 0)';
        }
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* Reviews marquee variant — same rAF pattern but selector scoped to the
     reviews-marquee's viewport (the tracks live inside a dedicated viewport
     element rather than directly under the marquee root). */
  function initReviewsMarquee(root) {
    var viewport = root.querySelector('.foshe-reviews-marquee__viewport');
    if (!viewport) return;
    var tracks = viewport.querySelectorAll('.foshe-reviews-marquee__track');
    if (tracks.length === 0) return;

    var durationRaw = getComputedStyle(viewport).getPropertyValue('--review-marquee-duration').trim();
    var durationSec = parseFloat(durationRaw) || 70;

    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) durationSec = durationSec * 3;

    var durationMs = durationSec * 1000;
    var paused = false;
    var pauseStartedAt = 0;
    var loopOrigin = performance.now();

    root.addEventListener('mouseenter', function () {
      if (!paused) { paused = true; pauseStartedAt = performance.now(); }
    });
    root.addEventListener('mouseleave', function () {
      if (paused) { paused = false; loopOrigin += performance.now() - pauseStartedAt; }
    });

    function frame(now) {
      if (!paused) {
        var elapsed = (now - loopOrigin) % durationMs;
        var progress = elapsed / durationMs;
        var translate = -progress * 100;
        for (var i = 0; i < tracks.length; i++) {
          tracks[i].style.transform = 'translate3d(' + translate + '%, 0, 0)';
        }
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function bootAll() {
    var marquees = document.querySelectorAll('.foshe-marquee');
    for (var i = 0; i < marquees.length; i++) {
      if (!marquees[i].dataset.fosheMarqueeInit) {
        marquees[i].dataset.fosheMarqueeInit = '1';
        initMarquee(marquees[i]);
      }
    }
    var reviewsMarquees = document.querySelectorAll('.foshe-reviews-marquee');
    for (var j = 0; j < reviewsMarquees.length; j++) {
      if (!reviewsMarquees[j].dataset.fosheMarqueeInit) {
        reviewsMarquees[j].dataset.fosheMarqueeInit = '1';
        initReviewsMarquee(reviewsMarquees[j]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  // Re-init on Shopify editor section load (theme editor live preview).
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('.foshe-marquee')) bootAll();
  });
})();
